import "babel-polyfill";
import Vue from 'vue';
import '../sass/style.scss';

var Equiem = { Vue };

// Autoload all the .vue and .amd.js files which are not:
// - example components
// - in the styleguide directory
// - .amd.vue AMD components
var requireContext = require.context(
  '../components',
  true,
  /^((?!styleguide\/)(?!amd\.vue)(?!example\.vue).)*(\.vue$)|(\.amd\.js$)/
);

var isReservedTag = function(tag) {
  // Identify tags which are named after html components.
  return Vue.config.isReservedTag(tag) || tag.match(/(blockquote)/);
};

var components = {};

Equiem = requireContext.keys().reduce((modules, filename) => {
  // Load the module from this file.

  // File name is in kebab case.
  let parts = filename.match(/([^\/\.]+)((\.vue)|(\.amd\.js)$)/);
  let kebabName = parts[1];

  // If the filename finishes with *.amd.js then it should be a module which
  // support asynchronous loading.
  let isAmd = (typeof parts[3] == 'undefined') ? true : false;

  // Convert to CamelCase.
  let camelName = kebabName
    .replace(/(\b|\W)\w/g, match => match.replace(/\W/g, '').toUpperCase());

  if (isAmd) {
    // AMD modules are loaded over the network only when first used.
    modules[camelName] = function(userOptions) {
      let promise = null;

      if (!components[kebabName]) {
        // Only require the file the first time it's loaded.
        promise = requireContext(filename)
          .then(config => {
            components[kebabName] = Vue.extend(config);
            Vue.component(kebabName, components[kebabName]);
            return components[kebabName];
          })
      }
      else {
        // Return the pre-loaded component.
        promise = Promise.resolve(components[kebabName]);
      }

      // Instantiate the component with the user options.
      return promise.then(component => new component(userOptions));
    };
  }
  else {
    // Not an AMD module, so load it immediately, but still return a Promise
    // for consistency. It's important that we load all the non-AMD modules
    // synchronously here because, for example, this it was loads the CSS for
    // the style-only components.
    let config = requireContext(filename);

    // Filter out html tag names.
    if (!isReservedTag(kebabName)) {
      // Add non-reserved modules to the modules accumulator object as Vue
      // components.
      components[kebabName] = Vue.extend(config);
      Vue.component(kebabName, components[kebabName]);

      // For consistency the module is exposed like an AMD module, even though
      // it's not.
      modules[camelName] = function(userOptions) {
        return Promise.resolve(new components[kebabName](userOptions));
      };
    }
  }

  return modules;
}, Equiem);

module.exports = Equiem;



// WEBPACK FOOTER //
// ./app/js/equiem.js